import React from 'react';
import './modal.css';
import Button from "../button/button";

function Modal({ methodButton, textButton, children, hidden, setShowModal }) {
    const modalRef = React.useRef(null);

    React.useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowModal(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setShowModal]);

    return (
        <div className="modal-area" hidden={hidden} ref={modalRef}>
            <div className={'content'} >
                {children}
            </div>
            <br/>
            {textButton &&
                <Button method={methodButton}>{textButton}</Button>
            }
        </div>
    );
}

export default Modal;